module.exports = __webpack_public_path__ + "img/icon-plus-circular.67636a1d.svg";